import { FC } from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { useBreakpoints } from 'hooks';

import usePromiseStatus from 'hooks/usePromiseStatus';

import { Button } from 'components/_basic/Button/Button';
import { Modal } from 'components/_basic/Modal';
import { IModalProps } from 'components/_basic/Modal/types';

import styles from './ChangeDocumentTypeModal.module.scss';

interface IProps extends IModalProps {
  docType: string;
  onCreateDoc: () => Promise<void>;
}

export const ChangeDocumentTypeModal: FC<IProps> = ({ close, docType, onCreateDoc }) => {
  const { isMobile } = useBreakpoints();
  const { track, isPending } = usePromiseStatus();

  const createDocHandler = async () => {
    await track(onCreateDoc());
    close()
  };

  return (
    <Modal close={close}>
      <Grid container maxWidth="500px" gap="24px">
        <Grid item xs={12}>
          <Typography variant={isMobile ? 'h4' : 'h3'}>Create {docType}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            Create {docType} Document using Information from current Business Plan?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box className={styles.buttonWrapper}>
            <Button isLoading={isPending} disabled={isPending} onClick={close} variant="outlined" fullWidth>
              Cancel
            </Button>
            <Button isLoading={isPending} disabled={isPending} onClick={createDocHandler} variant="contained" fullWidth>
              Create {docType}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Modal>
  );
};
